import React from 'react';
import { InputField as Input } from '@vds/inputs';
import styled from 'styled-components';

import { enableVerifyButton } from './../../action/buildProduct';

const VerificationCodeInput = styled(Input)`
  input {
    font-weight: normal;
  }
`;
const Div = styled.div`
  width: 100%;
`;

class VerificationCode extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
        error: false,
        success: !!(this.props.isValid && this.props.value),
        scVerificationTrack: '',
        };
        this.onChange = this.props.onVerificationCodeChange;
    }

    onChangeHandler = (e) => {
        const verificationCode = e.target.value;
        const pattern = /^[0-9]{1,6}$/;
        if (pattern.test(verificationCode)) {
        if (this.state.success !== true) {
            this.setState({ scVerificationTrack: 'verification code entered' });
        }
        this.setState({ error: false, success: true });
        this.onChange(e.target.value, true);
        } else if (this.props.required && e.target.value === '') {
        this.setState({ error: false, success: false });
        this.onChange(e.target.value, true);
        } else {
        this.setState({ error: true, success: false });
        this.onChange(e.target.value, false);
        }
        if (verificationCode.length === 6) {
        enableVerifyButton(this.props.dispatch, true);
        } else {
        enableVerifyButton(this.props.dispatch, false);
        }
    };

    isNNumeric = (e) => {
        const keyCode = e.which ? e.which : e.keyCode;
        if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || keyCode === 8 || keyCode === 9 || e.ctrlKey) {
        return true;
        }
        e.preventDefault();
        return false;
    };

    preventCutCopyPasteHandler = (e) => {
        e.preventDefault();
        return false;
    }

    render() {
        return (
        <>
        <Div>
            <VerificationCodeInput
                type="verificationcode"
                id="verification Code"
                label="Verification Code"
                value={this.props.value}
                error={this.state.error}
                errorText="Please enter valid verificationcode."
                success={this.state.success}
                onKeyDown={this.isNNumeric}
                onKeyPress={this.isNNumeric}
                onChange={this.onChangeHandler}
                onCut={this.onChangeHandler}
                onCopy={this.preventCutCopyPasteHandler}
                onPaste={this.onChangeHandler}
                required={this.props.required}
                maxLength={12}
                data-cs-mask
            />
        </Div>
        </>
        );
    }
}

export default VerificationCode;
